<template>
  <div class="workstation_edit_didEid_pop" v-if="currThemeObj">
    <el-drawer
      title="筛选比赛"
      :visible.sync="drawerFlag"
      :with-header="false"
      :custom-class="'workstation_selectMatch_pop'"
      @closed="closeDrawerEvent('didEid')"
    >
      <div class="select_area">
        <marathon_select_opt
          :currThemeObj="currThemeObj"
          :data="selectOptData"
          :inputObject="select_opt_inputObject"
          @changeSelectEvent="changeSelect"
          @inputValEvent="inputValHandler"
        ></marathon_select_opt>
      </div>
      <schedule_match_list
        :currCid="currItem_params.competitionId"
        :currSid="currItem_params.seasonId"
        :currThemeObj="currThemeObj"
        :data="dateMatchList"
        :detailPathName="'CSMeetSportDetailScheduleDetailStartList'"
        :chooseState="'default'"
        :matchModeObj="scheduleMatchList_matchMode"
        :themeClass="'poster'"
        @posterEvent="posterEventHandler"
      />
    </el-drawer>
  </div>
</template>

<script>
// 根据 大小项 |日期 筛选比赛 的弹窗
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import schedule_match_list from '@components/platfromBase/generalComponents/scheduleMatchList_compex/index.vue'
// import allMatchList from './allMatchList.js'
export default {
  name: 'workstation_edit_didEid_pop',
  components: { marathon_select_opt, schedule_match_list },
  props: {
    currThemeObj: {
      type: Object,
      default: null,
    },
    axiosBaseUrl: {
      type: String,
      default: '',
    },
    currItem_params: {
      type: Object,
      default: () => ({
        analysisTypeId: '',
        competitionId: 'cid',
        seasonId: 'sid',
        sportsId: 'did',
        eventId: 'eid',
        date: 'dateId',
        designStyleId: '',
        posterAnalysis: {}, //小项对应的分析项id
        sportType: '',
        urlPrefix: '', //获取主题接口的根路径
      }),
    },
    seasonArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    bigSportsArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    // sportEventsArr: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   },
    // },
    allMatchList: {
      type: Array,
      default: () => {
        return []
      },
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    selectOptData_origin: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      drawerFlag: false,
      select_opt_inputObject: {
        inputTitle: '快速查询',
        placeholder: '请输入比赛名称',
        iconType: 'search',
      }, //控制marathon_select_opt中的输入框是否显示
      currStageBigSports: '',
      currStageEvent: '',
      currStageMatchDate: '',
      curInputVal: '',
      sportEventsArr: [],
      matchDateArr: [],
      selectOptData: null,
      scheduleMatchList_matchMode: {
        mode: 'compreSportsMeet',
      },
      dateMatchList: [],
    }
  },
  computed: {},
  watch: {
    allMatchList(newVal, oldVal) {
      this.changeToRefreshData()
    },
    immediate: false,
    deep: true,
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.drawerFlag = this.isOpen

      this.selectOptData_origin.configArr.forEach((selecItem) => {
        if (selecItem.type === 'bigSports') {
          this.sportEventsArr = this.bigSportsArr[selecItem.selectIndex].events
        }
      })
      console.debug(
        'this.currItem_params:',
        this.allMatchList,
        this.currItem_params,
        this.bigSportsArr,
        this.sportEventsArr
      )
      // window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.selectOptData = JSON.parse(JSON.stringify(this.selectOptData_origin))
      if (this.currItem_params.sportsId && this.currItem_params.eventId) {
        // 选择框重新赋值，解决二次打开时选择框中的值跟比赛对不上问题
        console.debug(
          'this.selectOptData:',
          this.currItem_params,
          this.bigSportsArr
        )
        this.bigSportsArr.forEach((sportsItem, sportsIndex) => {
          if (sportsItem.disciplineId === this.currItem_params.sportsId) {
            console.debug(
              'this.selectOptData1:',
              sportsItem,
              this.currItem_params
            )
            this.sportEventsArr = sportsItem.events
            this.selectOptData.configArr.forEach((selecItem) => {
              if (selecItem.type === 'bigSports') {
                selecItem.selectIndex = sportsIndex
              }
            })
          }
        })
        this.sportEventsArr.forEach((eventItem, eventIndex) => {
          if (eventItem.eventId === this.currItem_params.eventId) {
            this.selectOptData.configArr.forEach((selecItem) => {
              if (selecItem.type === 'event') {
                selecItem.selectIndex = eventIndex
              }
            })
          }
        })
        console.debug('this.selectOptData:', this.selectOptData)
        this.changeToRefreshData()
      }
      // window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    changeToRefreshData() {
      this.getDateMatchList()
      const fristMatchItem = this.allMatchList[0]
      this.computedSelectOpt(this.selectOptData.configArr)
    },
    getDateMatchList() {
      console.debug('this.allMatchList:', this.allMatchList)
      const formatDateArr = []
      const matchDateArr = []
      this.allMatchList.forEach((matchItem, matchIndex) => {
        if (!formatDateArr.includes(matchItem.formatDate)) {
          formatDateArr.push(matchItem.formatDate)
          matchDateArr.push({
            startIndex: matchIndex,
            value: matchItem.startDatetimeUtc
              ? matchItem.startDatetimeUtc.split('T')[0]
              : '',
            name: matchItem.formatDate,
          })
        }
      })
      console.debug('matchDateArr:', matchDateArr)
      this.matchDateArr = matchDateArr
      this.computedMatchList(this.allMatchList, matchDateArr[0].value)
    },
    posterEventHandler(data) {
      // 选中比赛，除非回调函数
      // type==='poster',区分页面视图用的；在这里换成新的词
      const { type, data: matchItem } = data

      this.$emit('changeMatchItemEvent', {
        type: 'actMatch',
        data: matchItem,
      })

      this.closeDrawerEvent('match')
    },
    closeDrawerEvent(state) {
      this.drawerFlag = false
      setTimeout(() => {
        let type = state ? state : 'pop'
        this.$emit('closeDoneEvent', {
          type,
        })
      }, 400)
    },
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug('inputVal:', inputVal)
      this.curInputVal = inputVal
      if (inputVal) {
        // 有值则查询
        const dateMatchList = []
        this.dateMatchList_orgin.forEach((matchItem) => {
          if (matchItem.matchName.indexOf(inputVal) > -1) {
            dateMatchList.push(matchItem)
          }
        })

        this.dateMatchList = dateMatchList
      } else {
        if (this.dateMatchList_orgin) {
          this.dateMatchList = this.dateMatchList_orgin
        }
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        console.debug(
          'computedSelectOpt:',
          config.dataName,
          config,
          this[config.dataName],
          list,
          mix_id
        )
        selectOpt_list.push({
          type: config.type,
          title: config.title,
          keyVal: [mix_id, config.origin_keyVal[1]],
          curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
          curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
          disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
          isFilterable: config.isFilterable ? config.isFilterable : false,
          list,
        })
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          let emitData = {}
          if (valPathArr[0] === 'bigSports') {
            // let selectAllObj = JSON.parse(JSON.stringify(this.selectAllObj))
            // this.currStageBigSports = valPathArr[1]
            let currStageEvent = ''
            let posterAnalysis = null
            this.bigSportsArr.forEach((sportItem, sportsIndex) => {
              if (sportItem.value === valPathArr[1]) {
                this.sportEventsArr = sportItem.events
                currStageEvent = this.sportEventsArr[0].value
                posterAnalysis = this.sportEventsArr[0].posterAnalysis
                this.selectOptData.configArr[0].selectIndex = sportsIndex
                this.selectOptData.configArr[1].selectIndex = 0 //小项 默认第一个
                this.selectOptData.configArr[2].selectIndex = 0 //日期 默认第一个
              }
            })
            // this.computedSelectOpt(this.selectOptData.configArr)
            emitData = {
              // 回到父级加载比赛数据，然后修改日期数组，最终重新组装selectList
              type: valPathArr[0],
              value: [valPathArr[1], currStageEvent],
              posterAnalysis,
            }
          } else if (valPathArr[0] === 'sportEvents') {
            let posterAnalysis = null
            this.sportEventsArr.forEach((eventItem, eventIndex) => {
              if (eventItem.value === valPathArr[1]) {
                posterAnalysis = eventItem.posterAnalysis
                this.selectOptData.configArr[1].selectIndex = eventIndex
                this.selectOptData.configArr[2].selectIndex = 0 //日期 默认第一个
              }
            })
            emitData = {
              // 回到父级加载比赛数据，然后修改日期数组，最终重新组装selectList
              type: valPathArr[0],
              value: [this.currItem_params.sportsId, valPathArr[1]],
              posterAnalysis,
            }
          } else if (valPathArr[0] === 'matchDate') {
            this.computedMatchList(this.allMatchList, valPathArr[1])
          }
          if (['bigSports', 'sportEvents'].includes(valPathArr[0])) {
            this.$emit('changeSelectItemEvent', emitData)
          }
          // 筛选表格逻辑
          // this.initMatchListQuery()
          // this.getScheduleMatchList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    computedMatchList(list, dateId) {
      let dateMatchList = []
      if (dateId) {
        if (list && list.length > 0) {
          list.forEach((item) => {
            if (
              item.startDatetimeUtc &&
              item.startDatetimeUtc.split('T')[0] === dateId
            ) {
              dateMatchList.push(item)
            }
          })
          console.debug('computedMatchList end:', dateMatchList)
        }
      }

      this.dateMatchList = dateMatchList
      this.dateMatchList_orgin = JSON.parse(JSON.stringify(dateMatchList))
      if (this.curInputVal) {
        // 如果模糊查询有值，则再筛选一次
        this.inputValHandler(this.curInputVal)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.workstation_edit_didEid_pop {
  width: 100%;
  .select_area {
    /* position: relative; */
    /* position: sticky; */
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }
}
</style>
<style lang="scss">
.workstation_selectMatch_pop {
  width: 80% !important;
  padding: 1.388vw 0.694vw;
  .base_select_opt.el-popper[x-placement^='bottom'] {
    position: absolute !important;
    top: 4.6vw !important;
  }
}
</style>
